import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0f0b1a86"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "path-mask-layer"
};
const _hoisted_2 = ["onClick"];
const _hoisted_3 = {
  class: "navigation-frame"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "qh-icon-more"
}, null, -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "current-path"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "title"
}, "下载路径选择")], -1));
const _hoisted_6 = {
  key: 0,
  class: "file-frame"
};
const _hoisted_7 = {
  key: 1,
  class: "empty"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "历史记录", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _ctx$historyDownloadP;
  const _component_PathItem = _resolveComponent("PathItem");
  const _component_Spin = _resolveComponent("Spin");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
    class: "footer-frame",
    onClick: _withModifiers(() => null, ["stop"])
  }, [_createElementVNode("div", _hoisted_3, [_createElementVNode("span", {
    class: _normalizeClass(["back-path", {
      hidden: _ctx.isInRoot
    }]),
    onClick: _cache[0] || (_cache[0] =
    //@ts-ignore
    (...args) => _ctx.getUpperPath && _ctx.getUpperPath(...args))
  }, [_hoisted_4, _createTextVNode("返回")], 2), _hoisted_5, _createElementVNode("a", {
    href: "javascript:;",
    class: "close-frame qh-icon-close",
    onClick: _cache[1] || (_cache[1] =
    //@ts-ignore
    (...args) => _ctx.closeFrame && _ctx.closeFrame(...args))
  })]), _ctx.showTrees ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_ctx.showTrees.children.length ? (_openBlock(true), _createElementBlock(_Fragment, {
    key: 0
  }, _renderList(_ctx.showTrees.children, (path, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      class: "path-node"
    }, [_createVNode(_component_PathItem, {
      index: index,
      path: path,
      onHandleGetIn: $event => _ctx.handleGetIn(index),
      onHandleDelete: _ctx.handleDelete
    }, null, 8, ["index", "path", "onHandleGetIn", "onHandleDelete"])]);
  }), 128)) : !_ctx.isLoading ? (_openBlock(), _createElementBlock("div", _hoisted_7, " 该文件夹下无其他目录 ")) : _createCommentVNode("", true), _ctx.isInRoot && (_ctx$historyDownloadP = _ctx.historyDownloadPath) !== null && _ctx$historyDownloadP !== void 0 && _ctx$historyDownloadP.length ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 2
  }, [_hoisted_8, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.historyDownloadPath, (path, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      class: "path-node"
    }, [_createVNode(_component_PathItem, {
      index: index,
      path: path,
      onHandleGetIn: $event => _ctx.handleGetIn(index, true),
      onHandleDelete: _ctx.handleDelete
    }, null, 8, ["index", "path", "onHandleGetIn", "onHandleDelete"])]);
  }), 128))], 64)) : _createCommentVNode("", true)])) : _createCommentVNode("", true), _createElementVNode("div", {
    class: "other-directory",
    onClick: _cache[2] || (_cache[2] =
    //@ts-ignore
    (...args) => _ctx.handleToast && _ctx.handleToast(...args))
  }, [_createElementVNode("span", null, "下载到：" + _toDisplayString(_ctx.shortCurrentDownloadPath), 1)]), _createElementVNode("div", {
    class: _normalizeClass(["submit-frame", {
      disabled: !_ctx.showTrees.isWrite
    }]),
    onClick: _cache[3] || (_cache[3] =
    //@ts-ignore
    (...args) => _ctx.okFrame && _ctx.okFrame(...args))
  }, " 确定 ", 2)], 8, _hoisted_2), _ctx.isLoading ? (_openBlock(), _createBlock(_component_Spin, {
    key: 0,
    "show-cover": "",
    top: 300
  })) : _createCommentVNode("", true)]);
}